import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { OdooClient } from '@trace/connector';
import { useOdoo } from '../../context/OdooContext.js';

export default function LoginScreen() {
  const { setClient } = useOdoo();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    baseUrl: import.meta.env.VITE_ODOO_URL ?? '',
    db: import.meta.env.VITE_ODOO_DB ?? '',
    login: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  function set(k: string, v: string) { setForm(f => ({ ...f, [k]: v })); }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const client = new OdooClient({ baseUrl: form.baseUrl, db: form.db });
      await client.login(form.login, form.password);
      setClient(client);
      navigate('/');
    } catch {
      setError('Identifiants incorrects ou serveur Odoo inaccessible.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-3xl font-extrabold bg-gradient-to-br from-brand to-indigo-400 bg-clip-text text-transparent">
            TRACE Energy AI
          </div>
          <p className="text-ink-3 text-sm mt-1">Générateur de CCTP — Connexion Odoo</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-card p-8 space-y-4">
          <div>
            <label className="text-xs font-semibold text-ink-2 block mb-1">URL Odoo</label>
            <input
              type="text"
              placeholder="http://82.165.105.77:8069"
              value={form.baseUrl}
              onChange={e => set('baseUrl', e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-line text-sm focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/10"
              required
            />
          </div>

          <div>
            <label className="text-xs font-semibold text-ink-2 block mb-1">Base de données</label>
            <input
              type="text"
              placeholder="trace_prod"
              value={form.db}
              onChange={e => set('db', e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-line text-sm focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/10"
              required
            />
          </div>

          <div>
            <label className="text-xs font-semibold text-ink-2 block mb-1">Email</label>
            <input
              type="text"
              placeholder="admin ou email@exemple.com"
              value={form.login}
              onChange={e => set('login', e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-line text-sm focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/10"
              required
            />
          </div>

          <div>
            <label className="text-xs font-semibold text-ink-2 block mb-1">Mot de passe</label>
            <input
              type="password"
              value={form.password}
              onChange={e => set('password', e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-line text-sm focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/10"
              required
            />
          </div>

          {error && (
            <div className="bg-red-soft text-red text-sm rounded-lg px-3 py-2">{error}</div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 bg-brand hover:bg-brand-dark text-white font-semibold rounded-lg transition-colors disabled:opacity-60"
          >
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}
